import { getPlatform } from './platform.js';

const resolveByPlatform = (value) => {
  if (getPlatform().isMac) {
    return value == null ? void 0 : value.mac;
  }
  if (getPlatform().isWin) {
    return value == null ? void 0 : value.win;
  }
  return void 0;
};

export { resolveByPlatform };
//# sourceMappingURL=resolveByPlatform.js.map
